<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
    <div class=" pb-4 text-center">
        <h4 *ngIf="active">{{'Are you sure you whant to suspend this user'|translate}}</h4>
        <h4 *ngIf="!active">{{'Are you sure you whant to unsuspend this user'|translate}}</h4>
    </div>

    <div class="d-flex flex-row justify-content-between pb-4">
        <button *ngIf="active" class="btn_in_color" (click)="suspendsubcriber()">{{ 'SUSPEND' |
            translate}}</button>
        <button *ngIf="!active" class="btn_in_color" (click)="unsuspendsubcriber()">{{ 'UNSUSPEND' |
            translate}}</button>
        <button class="btn_without_color" (click)="cancel()">{{ 'CANCEL' | translate }}</button>
    </div>
</div>